import type { People, PeopleIndex } from '../types';

export function usePeopleIndex(people: People): PeopleIndex {
  const index: PeopleIndex = {};
  for (const person of people) {
    index[person.id] = person;
  }
  return index;
}
